import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs11() {
  return (
    <div>
      <Heading
        type="h3"
        title={
          <>
            {`XI.`}
            <br />
            {` Závěrečná ustanovení
`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Pokud vztah založený smlouvou obsahuje mezinárodní (zahraniční) prvek, pak strany sjednávají, že vztah se řídí českým právem. Tímto nejsou dotčena práva spotřebitele vyplývající z obecně závazných právních předpisů.`}</li>
            <li>{`Poskytovatel není ve vztahu k uživateli vázán žádnými kodexy chování ve smyslu ustanovení § 1826 odst. 1 písm. e) občanského zákoníku.`}</li>
            <li>{`K mimosoudnímu řešení spotřebitelských sporů ze smlouvy je příslušná Česká obchodní inspekce, se sídlem Štěpánská 567/15, 120 00 Praha 2, IČ: 000 20 869, internetová adresa: http://www.coi.cz `}</li>
            <li>{`Uživatel tímto přebírá na sebe nebezpečí změny okolností ve smyslu § 1765 odst. 2 občanského zákoníku.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={5} className={sList}>
            <li>{`Je-li některé ustanovení obchodních podmínek neplatné nebo neúčinné, nebo se takovým stane, namísto neplatných ustanovení nastoupí ustanovení, jehož smysl se neplatnému ustanovení co nejvíce přibližuje. Neplatností nebo neúčinností jednoho ustanovení není dotknutá platnost ostatních ustanovení. Změny a doplňky kupní smlouvy či obchodních podmínek vyžadují písemnou formu.`}</li>
            <li>{`Smlouva včetně obchodních podmínek je archivována poskytovatelem v elektronické podobě a není přístupná.`}</li>
            <li>{`Přílohu obchodních podmínek tvoří vzorový formulář pro odstoupení od smlouvy.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs11;
